import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetIndicationMapAddressResponse,
  GetIndicationMapByIdResponse,
  GetLocationResponse,
  PostIndicationMapResponse,
  PutIndicationMapResponse,
} from '../response/location';

export class LocationService {
  static getIndicationMap(params?: QueryParams) {
    return apiClient.get<GetLocationResponse>(buildApiUrl('/api/v1/location/indication-maps'), params);
  }

  static postIndicationMap(data: any) {
    return apiClient.createWithFile<PostIndicationMapResponse>(buildApiUrl('/api/v1/location/indication-maps'), data);
  }

  static putIndicationMap(id: string, data: any) {
    const url = buildApiUrl('/api/v1/location/indication-maps/:id', { id });
    return apiClient.updateWithFile<PutIndicationMapResponse>(url, data);
  }

  static getIndicationMapById(id: string) {
    const url = buildApiUrl('/api/v1/location/indication-maps/:id', { id });
    return apiClient.get<GetIndicationMapByIdResponse>(url, undefined);
  }

  static deleteIndicationMap(id: string) {
    const url = buildApiUrl('/api/v1/location/indication-maps/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }

  static getIndicationMapAddressByPostalCode(postalCode: string) {
    return apiClient.get<GetIndicationMapAddressResponse>(buildApiUrl('/api/v1/location/indication-maps/address'), {
      postal_code: postalCode,
    });
  }
}
